<template>
  <q-dialog
    width="820px"
    :visible="isVisible"
    :innerScroll="false"
    :title="actionMap[actionType]"
    :loading="loadingBtn"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="confirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="110px" size="small" v-loading="loading">
      <el-row class="mb5">
        <template v-if="actionType === 'add'">
          <el-col :span="12">
            <el-form-item label="评审批次" prop="reviewBatchNo">
              <el-input v-model.trim="addForm.reviewBatchNo" size="small" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评审编码" prop="reviewCode">
              <el-input v-model.trim="addForm.reviewCode" size="small" maxlength="14"></el-input>
            </el-form-item>
          </el-col>
        </template>
        <template v-if="actionType === 'modify'">
          <el-col :span="24">
            <el-form-item label="评审编码">
              <span>{{addForm.reviewCode}}</span>
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="12">
          <el-form-item label="产品型号" prop="productType">
            <el-input v-model.trim="addForm.productType" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model.trim="addForm.productCode" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品类" prop="veriety">
            <el-input v-model.trim="addForm.veriety" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品类细分" prop="category">
            <el-input v-model.trim="addForm.category" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品描述" prop="productDesc">
            <el-input v-model.trim="addForm.productDesc" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="风格" prop="style">
            <el-select v-model="addForm.style">
              <el-option :label="item" :value="item" v-for="(item, index) in allOptions.styleNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="打样型号" prop="demoType">
            <el-input v-model.trim="addForm.demoType" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="材质" prop="texture">
            <el-select v-model="addForm.texture">
              <el-option :label="item" :value="item" v-for="(item, index) in allOptions.textureNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="空间" prop="spaceRoom">
            <el-select v-model="addForm.spaceRoom">
              <el-option :label="item" :value="item" v-for="(item, index) in allOptions.spaceRoomNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="尺寸" prop="measure">
            <el-input v-model.trim="addForm.measure" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属板块" prop="belongModule">
            <el-select v-model="addForm.belongModule">
              <el-option :label="item" :value="item" v-for="(item, index) in allOptions.belongModuleNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="研发类型" prop="developType">
            <el-select v-model="addForm.developType">
              <el-option :label="item" :value="item" v-for="(item, index) in allOptions.developTypeNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="颜色" prop="mainColor">
            <el-input v-model.trim="addForm.mainColor" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="功能" prop="useFunction">
            <el-select v-model="addForm.useFunction">
              <el-option :label="item" :value="item" v-for="(item, index) in allOptions.useFunctionNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="款式" prop="styleType">
            <el-select v-model="addForm.styleType">
              <el-option :label="item" :value="item" v-for="(item, index) in allOptions.styleTypeNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="长" prop="length">
            <el-input v-model.trim="addForm.length" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="宽" prop="width">
            <el-input v-model.trim="addForm.width" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否有样" prop="hasDemo">
            <el-select v-model="addForm.hasDemo">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="价格" prop="price">
            <el-input v-model.trim="addForm.price" size="small" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图片" prop="pictures">
            <el-upload v-if="showBatchUpload"
              :action="uploadUrl"
              multiple
              :limit="5"
              name="files"
              :headers="uploadHeader"
              accept=".jpg,.jpeg,.gif,.png"
              :before-upload="beforeUpload"
              :on-success="onBatchUpload"
              :on-error="onBatchUploadFail"
              :show-file-list="false">
              <el-button size="small" type="success">批量上传</el-button>              
            </el-upload>

            <div class="picture-wrap" v-else>
              <el-upload v-for="item in pictures" :key="item.key"
                class="avatar-uploader"
                :action="uploadUrl"
                name="files"
                accept=".jpg,.jpeg,.gif,.png"
                :show-file-list="false"
                :headers="uploadHeader"
                :before-upload="beforeUpload"
                :on-success="onUploadSuccess"
                :on-error="onUploadFail">
                <img v-if="item.url" :src="item.url" class="avatar" @click="onClickUpload(item)" />
                <i v-else class="el-icon-plus avatar-uploader-icon" @click="onClickUpload(item)"></i>
                <div class="operate-layer" v-if="item.url" @click="onClickUpload(item)">
                  <i class="el-icon-copy-document avatar-edit-icon"></i>
                  <i class="el-icon-delete avatar-del-icon" @click.stop="onClickDelete(item)"></i>
                </div>
              </el-upload>
            </div>
            <p class="pic-tip">
              <i class="el-icon-warning-outline"></i> 最多可上传5张图片</p>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import { baseUrl } from '@/utils/constant'
import selectOptionsMixin from './select-options.mixin'
import { getToken } from '@/utils/auth'
import validator from 'validator';
export default {
  mixins: [selectOptionsMixin],
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 操作类型add，modify
    actionType: {
      type: String,
      required: true
    },
    // 修改时初始化数据
    rowData: Object,
  },
  data() {
    const isFloat = (rule, value, callback) => {
      if(!value) {
        callback();
        return;
      }
      if(validator.isFloat(value)){
        const status = RegExp(/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,1})?$/).test(value);
        if(status) {
          callback()
        }else{
          callback(new Error('请保留一位小数点'))
        }
      }else{
        callback(new Error('请输入数字'))
      }
    }
    const isDate = (rule, value, callback, limit) => {
      let extra = value.substring(8);
      if(extra.length != limit) {
        callback(new Error(`格式校验失败，请参考\'YYYYMMDD+${limit}位随机数\'`))
        return;
      }
      value = value.substring(0,8).split('');
      value.splice(4,0,'/')
      value.splice(7,0,'/');
      value = value.join('');
      let valid = validator.isDate(value, {
        format: 'YYYY/MM/DD',
        strictMode: true
      });
      if(valid) {
        callback();
      }else{
        callback(new Error(`格式校验失败，请参考\'YYYYMMDD+${limit}位随机数\'`))
      }
    }
    const isReviewCode = (rule, value, callback, limit) => {
      if(!value) {
        callback();
        return;
      }
      let extra = value.substring(10);
      let begin = value.substring(0,2);
      if(begin !== 'DS') {
        callback(new Error(`格式校验失败，请参考\'DSYYYYMMDD+${limit}位随机数\'`))
        return;
      }
      if(extra.length != limit) {
        callback(new Error(`格式校验失败，请参考\'DSYYYYMMDD+${limit}位随机数\'`))
        return;
      }
      value = value.substring(2,10).split('');
      value.splice(4,0,'/')
      value.splice(7,0,'/');
      value = value.join('');
      let valid = validator.isDate(value, {
        format: 'YYYY/MM/DD',
        strictMode: true
      });
      if(valid) {
        callback();
      }else{
        callback(new Error(`格式校验失败，请参考\'DSYYYYMMDD+${limit}位随机数\'`))
      }
    }
    return {
      uploadUrl: `${baseUrl}/ec-pc-api/file/upload/media`,
      uploadHeader: {
        Authorization: getToken()
      },
      currentUploadItem: null,
      loadingBtn: false,
      actionMap: {
        add: "新增",
        modify: "修改"
      },
      addForm: {
        reviewBatchNo: '',
        reviewCode: '',
        productDesc: '',
        veriety: '',
        category: '',
        demoType: '',
        style: '',
        spaceRoom: '',
        texture: '',
        belongModule: '',
        measure: '',
        mainColor: '',
        developType: '',
        styleType: '',
        useFunction: '',
        hasDemo: '',
        price: '',
        length: '',
        width: '',
        pictures: ''
      },
      videoName: '',
      addFormRules: {
        // reviewBatchNo: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        //   { validator: (rule, value, callback) => isDate(rule, value, callback, 3), trigger: 'blur' }
        // ],
        productType: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        productDesc: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        reviewCode: [
          { validator: (rule, value, callback) => {
            let limit = 4;
            // console.log(this.data.dataSource);
            // if(this.data.dataSource === '评审') {
            //   limit = 3;
            // }else{
            //   limit = 4;
            // }
            return isReviewCode(rule, value, callback, limit);
          }, trigger: 'blur' }
        ],
        measure: [
          { validator: isFloat, trigger: 'change' }
        ],
        price: [
          { validator: isFloat, trigger: 'change' }
        ],
        length: [
          { validator: isFloat, trigger: 'change' }
        ],
        width: [
          { validator: isFloat, trigger: 'change' }
        ]
      },

      pictures: [
        {
          key: 'pic1',
          fileName: '',
          url: '',
          id: ''
        },
        {
          key: 'pic2',
          fileName: '',
          url: '',
          id: ''
        },
        {
          key: 'pic3',
          fileName: '',
          url: '',
          id: ''
        },
        {
          key: 'pic4',
          fileName: '',
          url: '',
          id: ''
        },
        {
          key: 'pic5',
          fileName: '',
          url: '',
          id: ''
        }
      ],
      // 成功上传的图片路径列表
      batchList: [],
      // 标记选择的每个图片是否都已执行上传操作
      batchActionMap: {}
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    showBatchUpload() {
      return this.addForm.pictures === '';
    }
  },
  methods: {
    init() {
      if (this.actionType === 'add') {
        // this.getNo();
      } else if (this.rowData) {
        this.initModify();
      }
    },
    initModify() {
      const { 
        dataId, reviewBatchNo, reviewCode, productType, productCode, productDesc, veriety, category, demoType, style, spaceRoom, texture,
        belongModule, measure, mainColor, developType, useFunction, styleType, hasDemo, price, length, width, productMedias
      } = this.rowData;

      const addForm = {
        dataId, reviewBatchNo, reviewCode, productType, productCode, productDesc, veriety, category, demoType, style, spaceRoom, texture,
        belongModule, measure, mainColor, developType, useFunction, styleType, hasDemo, price, length, width
      };

      const pictures = [];
      let video = '';

      productMedias.forEach(item => {
        pictures.push({
          url: item.url,
          fileName: item.url,
          id: item.id
        });
      })

      addForm.video = video;
      addForm.pictures = pictures.map(v=>v.url).join(',');

      pictures.forEach((item, index) => {
        this.pictures[index].url = item.url;
        this.pictures[index].fileName = item.fileName;
        this.pictures[index].id = item.id;
      })

      this.addForm = addForm;
    },
    onCancel() {
      this.isVisible = false;
    },
    getNo() {
      this.$q.shopProduct.getProductNum().then(({code, data}) => {
        if (code !== 200) {
          this.$notify.error({
            title: "错误",
            message: '搜索产品编号失败'
          });
        } else {
          this.addForm.reviewCode = data
        }
      });
    },
    onClickUpload(uploadItem) {
      this.currentUploadItem = uploadItem;
    },
    onClickDelete(uploadItem) {
      uploadItem.url = '';
      this.addForm.pictures = this.pictures.map(item => item.url).filter(item => !!item).join(',')
    },
    beforeUploadVideo(file) {
      const isMP4 = file.type === 'video/mp4';
      const isGt10M = file.size / 1024 / 1024 > 10;

      if (!isMP4) {
        this.$message.error('上传视频只能是MP4格式!');
        return false;
      }

      if (isGt10M) {
        this.$message.error('上传视频大小不能超过 10MB!');
        return false;
      }
      return true;
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpg';
      const isJPEG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGt5M = file.size / 1024 / 1024 > 5;
      
      if (!isJPG && !isJPEG && !isPNG) {
        this.$message.error('上传图片只能是 jpg/jpeg/png 格式!');
        return false;
      }

      if (isGt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
      
      // 添加文件名
      if(this.currentUploadItem) this.currentUploadItem.fileName = file.name;
      return true;
    },
    onUploadSuccess(res) {
      if (+res.code === 200) {
        this.currentUploadItem.url = res.data[0].path;
        this.currentUploadItem.id = res.data[0].id;
        this.addForm.pictures = this.pictures.map(item => item.url).filter(item => !!item).join(',')
      }      
    },
    onUploadFail(err) {
      console.log('upload-err:', err);
    },
    onBatchUpload(res, file, fileList) {
      this.batchActionMap[file.name] = true;
      if (+res.code === 200) {
        this.batchList.push({
          name: file.name,
          url: res.data[0].path,
          id: res.data[0].id
        });
      }
      this.loadPicturesAfterUpload(fileList);
    },
    onBatchUploadFail(err, file, fileList) {
      this.batchActionMap[file.name] = true;
      this.loadPicturesAfterUpload(fileList);
    },
    loadPicturesAfterUpload(fileList = []) {
      // 批量操作未完成
      if (Object.keys(this.batchActionMap).length < fileList.length) {
        return;
      }

      // batchList按照fileList排序
      const uploadedUrls = [];
      fileList.forEach(file => {
        const loadedPic = this.batchList.find(item => file.name === item.name);
        if (loadedPic) {
          uploadedUrls.push({
            url: loadedPic.url,
            fileName: loadedPic.name,
            id: loadedPic.id
          });
        }
      })

      this.addForm.pictures = uploadedUrls.map(v=>v.url).join(',');

      uploadedUrls.forEach((item, index) => {
        this.pictures[index].url = item.url;
        this.pictures[index].fileName = item.fileName;
        this.pictures[index].id = item.id;
      })
    },
    
    upload({ file }) {
      this.$q.shopProduct.uploadRes(file).then(({code, message, data}) => {
        console.log(file.name, data);
        if (code === 200) {
          this.videoName = file.name;
          this.addForm.video = data;
        } else {
          this.$message.error(message);
        }
      })
    },
    confirm() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return;
        this.loadingBtn = true;
        const params = {};
        const medias = [];

        for(const [key, value] of Object.entries(this.addForm)) {
          if (key === 'video' && value) {
            medias.push({mediaType: 1, mediaName: this.videoName, url: value})
          } else if (key === 'pictures' && value) {
            medias.push(...value.split(',')
              .map(item => ({
                mediaType: 0,
                mediaName: this.pictures.find(v=>v.url===item).fileName,
                id: this.pictures.find(v=>v.url===item).id,
                url: item
              }))
            );
          } else {
            params[key] = value;
          }
        }
        params.productMedias = medias;

        console.log(params);
        
        this.$q.newProduct.reviewProductSaveOrUpdate({data: params})
        .then(({code, message}) => {
          const isSuccess = code == 200;
          this.showResult(isSuccess, message);
          if (isSuccess) {
            this.isVisible = false;
            this.$emit('success');
          }
        }).finally(() => {
          this.loadingBtn = false;
        });
      });
    },
    showResult(isSuccess = true, message) {
      if (isSuccess) {
        this.$notify.success({
          title: '成功',
          message: `评审产品${this.actionMap[this.actionType]}成功！`
        });
      } else {
        this.$notify.error({
          title: "错误",
          message
        });
      }
    },
    deleteVideo() {
      this.videoName = '';
      this.addForm.video = null;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="stylus" scoped>
.mb5
  margin-bottom 5px

.pic-tip
  color #999
  i
    font-size 16px

.description-input
  width 580px
.design-input
  width 215px

.item-text-input
  width 215px

.picture-wrap
  display flex
  line-height 1

.avatar-uploader
  margin-right 20px
  position relative
  >>> .el-upload
    border 1px dashed #d9d9d9
    border-radius 6px
    cursor pointer
    position relative
    overflow hidden
    &:hover
      border-color #409EFF
      .operate-layer
        display block
.operate-layer
  display none
  position absolute
  left 0
  top 0
  bottom 0
  right 0
  background rgba(0,0,0,0.2)
  content ""
  z-index 1
.avatar-del-icon,.avatar-edit-icon
  position absolute
  top 50%
  transform translate(0,-50%)
  color #ffffff
  font-size 20px
  z-index 2
.avatar-edit-icon
  left 20%
.avatar-del-icon
  left 60%
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 100px
  height 100px
  line-height 100px
  text-align center
.avatar
  width 100px
  height 100px
  display block

.upload-demo
  >>>.el-upload__tip
    line-height 12px

>>> .el-dialog__body
  height 400px
  overflow-y auto

>>> .el-input
 width 180px
</style>